import React from "react";
import BaseModal from "../BaseModal/index.tsx";
import CadastroConvenio from "../../CadastroConvenio/index.tsx";

const CadastroConvenioModal = ({ isOpen, onClose, onAdd }) => {
  return (
    <BaseModal isOpen={isOpen} title="Cadastro de Convenio" onClose={onClose}>
      <CadastroConvenio onAdd={onAdd} />
    </BaseModal>
  );
};

export default CadastroConvenioModal;
